// HOC for automatically scrolling to top whenever the route location updates
// This should only wrap components where this is necessary, not internal/UI routes

// react-redux-router has generic solution in the works for composing
// with either scrollToTop (from <Link/>) & restored scrolling (from back/forward)

// https://reacttraining.com/react-router/web/guides/scroll-restoration/generic-solution

import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { object, node } from 'prop-types';


class ScrollToTop extends Component {
    static propTypes = {
        location: object.isRequired,
        children: node.isRequired,
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            window.scrollTo(0, 0);
        }
    }

    render() {
        return this.props.children;
    }
}

export default withRouter(ScrollToTop);
